import { SVG, SVGProps } from './svg'

export function IconInfo(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm2 0a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm9 .5c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5v3c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-3ZM12.5 8c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1a.5.5 0 0 1-.5-.5v-1c0-.3.2-.5.5-.5h1Z"
      />
    </SVG>
  )
}
